export type GalleryRoute =
  | { readonly kind: 'models-index' }
  | { readonly kind: 'model-detail'; readonly id: string }
  | { readonly kind: 'environments-index' }
  | { readonly kind: 'environment-detail'; readonly id: string }
  | { readonly kind: 'not-found' };

export type AppRoute = GalleryRoute | {
  readonly kind: 'game';
  readonly screenshotMode: boolean;
  readonly screenshotBiome?: 'lanternwood' | 'blueIce' | 'timberline';
};

function routeSegments(pathname: string): string[] | null {
  try {
    return pathname
      .split('/')
      .filter(Boolean)
      .map((segment) => decodeURIComponent(segment));
  } catch {
    return null;
  }
}

export function parseAppRoute(pathname: string): AppRoute {
  const segments = routeSegments(pathname);
  if (!segments) return { kind: 'not-found' };
  if (segments.length === 0) return { kind: 'game', screenshotMode: false };
  if (segments.length === 1 && segments[0] === 'screenshot') {
    return { kind: 'game', screenshotMode: true };
  }
  if (
    segments.length === 2
    && segments[0] === 'screenshot'
    && ['lanternwood', 'blueIce', 'timberline'].includes(segments[1] ?? '')
  ) {
    return {
      kind: 'game',
      screenshotMode: true,
      screenshotBiome: segments[1] as 'lanternwood' | 'blueIce' | 'timberline',
    };
  }
  if (segments.length === 1 && segments[0] === 'models') return { kind: 'models-index' };
  if (segments.length === 2 && segments[0] === 'models' && segments[1]) {
    return { kind: 'model-detail', id: segments[1] };
  }
  if (segments.length === 1 && segments[0] === 'environments') return { kind: 'environments-index' };
  if (segments.length === 2 && segments[0] === 'environments' && segments[1]) {
    return { kind: 'environment-detail', id: segments[1] };
  }
  return { kind: 'not-found' };
}
